import { SelectForm } from '@/components/uiParts';
import { CustomGroup } from '@/pages/link-items/LinkItemsPage';
import { PosItemAndHandlePos } from '@/services/Pos';

export type DraftPosData = {
  [key: string]: PosItemAndHandlePos[];
};
export interface Storage {
  draft_pos_data: Partial<DraftPosData>;
  initialLinkedGroup: {
    groups: CustomGroup[];
  };
  menuManagement: {
    associateBrand?: SelectForm; // 本来は valueの命名をidに変えたいが、react-selectで扱っている型に合わせたいためSelectFormを使っている。
  };
  deliveryStoreStatus: {
    storeName: string;
    authStoreIds: number[];
    storeState: string;
    pendingReasons: string[];
  };
}

export class LocalStorageHandler {
  static get<K extends keyof Storage>(key: K): Storage[K] {
    const obj = localStorage.getItem(key);
    return obj ? JSON.parse(obj) : {};
  }

  static set<K extends keyof Storage>(key: K, value: Storage[K]): void {
    const obj = LocalStorageHandler.get(key);
    const newObj = { ...obj, ...value };
    localStorage.setItem(key, JSON.stringify(newObj));
  }

  static removeItem<K extends keyof Storage>(key: K): void {
    localStorage.removeItem(key);
  }
}
